// @flow
import config from '../../config';
import { makeAPICall, APIError } from '../generalCreators';
import { updateCurrentCustomer } from './currentCustomerCreators';
import {
  getOrganisations,
  requestOrganisationTypeUpdate
} from '../organisations/organisationCreators';
import type { ThunkAction, Organisation } from '../../types';

export function getCustomers(
  withPermissions: boolean = true,
  excludeArchived: boolean = false
): ThunkAction {
  return function(dispatch, getState) {
    const endpoint = '/organisations/access';
    const options = {
      method: 'GET',
      headers: { token: getState().authentication.token },
      params: {
        productId: config.productId,
        withPermissions,
        excludeArchived
      }
    };

    return makeAPICall(endpoint, options).then(
      response => {
        const customers = response.data.organisations;
        dispatch({ type: 'UPDATE_CUSTOMERS', customers });
      },
      error => dispatch(APIError(error, 'Error getting customers'))
    );
  };
}

export function getFilteredCustomers(
  text: string,
  excludeArchived: ?boolean = false
): ThunkAction {
  return function(dispatch, getState) {
    const endpoint = '/organisations/filter';
    const options = {
      method: 'GET',
      headers: { token: getState().authentication.token },
      params: {
        productId: config.productId,
        text,
        excludeArchived
      }
    };

    return makeAPICall(endpoint, options).then(
      response => {
        const customers = response.data.organisations;
        dispatch({ type: 'UPDATE_CUSTOMERS', customers });
      },
      error => dispatch(APIError(error, 'Error getting filtered organisations'))
    );
  };
}

export function addCustomer(organisation: Organisation): ThunkAction {
  return function(dispatch, getState) {
    const endpoint = '/organisations';
    const options = {
      method: 'POST',
      headers: { token: getState().authentication.token },
      params: { productId: config.productId },
      data: organisation
    };
    return makeAPICall(endpoint, options).then(
      response => {
        const newOrganisationId = response.data.id;
        dispatch(getCustomers());
        dispatch(getOrganisations());
        dispatch(updateCurrentCustomer(newOrganisationId));
        return response;
      },
      error => dispatch(APIError(error, 'Error creating organisation'))
    );
  };
}

export function updateCustomer(organisation: Organisation): ThunkAction {
  return function(dispatch, getState) {
    organisation.organisationAddressRecordDownloadLimit = parseInt(
      organisation.organisationAddressRecordDownloadLimit,
      10
    );
    organisation.organisationAmDownloadLimitTimePeriod = parseInt(
      organisation.organisationAmDownloadLimitTimePeriod,
      10
    );
    const endpoint = '/organisation';
    const options = {
      method: 'PUT',
      headers: { token: getState().authentication.token },
      params: {
        productId: config.productId,
        organisationId: organisation.id
      },
      data: organisation
    };
    return makeAPICall(endpoint, options).then(
      response => {
        if (organisation.agencyRequest) {
          // TODO: Remove hardcoded agency ID.
          dispatch(requestOrganisationTypeUpdate(organisation.id, 3));
        }
        dispatch(getCustomers());
        if (organisation.id) {
          dispatch(updateCurrentCustomer(organisation.id));
        }
        return response;
      },
      error => dispatch(APIError(error, 'Error updating Location'))
    );
  };
}



// WEBPACK FOOTER //
// ./src/actions/customers/basicCreators.js